import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: ReactNode;
  error?: string;
  hint?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, hint, id, className, ...rest },
  ref,
) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const errId = error ? `${inputId}-err` : undefined;
  const hintId = hint ? `${inputId}-hint` : undefined;
  const describedBy = [errId, hintId].filter(Boolean).join(' ') || undefined;

  return (
    <div className={['hsc-input', className].filter(Boolean).join(' ')}>
      <label htmlFor={inputId} className="hsc-input__label">
        {label}
      </label>
      <input
        ref={ref}
        id={inputId}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        className="hsc-input__field"
        {...rest}
      />
      {hint && (
        <span id={hintId} className="hsc-input__hint">
          {hint}
        </span>
      )}
      {error && (
        <span id={errId} role="alert" className="hsc-input__error">
          {error}
        </span>
      )}
    </div>
  );
});
